var preloader = (function() {

	var preloader = $("#preloader");
	var preloaderTitle = preloader.find(".box-title");
	var preloaderParagraph = preloader.find(".box-paragraph");

	function openPreloader(title, paragraph) {
		$('body').addClass('preloader-open');

		preloaderTitle.text(title);
		preloaderParagraph.text(paragraph);
	}
	function closePreloder() {
		$('body').removeClass('preloader-open');
			setTimeout(function() {
				preloaderTitle.text('');
				preloaderParagraph.text('');
			}, 0);
	}
	return {
		open: openPreloader,
		close: closePreloder,
	}
})();


export default preloader;